import { usePageState } from "@hg/recall-frame"
import { useActivityStatus, useJoinedTeam } from "@/hooks"
import { useCallback, useEffect, useRef, useState } from "react"

import InviteCodeModal from "@/components/InviteCodeModal"
import { login, useRoleInfo, useSessionReady } from "@/user/session"
import { Panel } from "../Panel"
import Poster from "../Poster"
import RuleModal from "../RuleModal"
import { TeamProvider } from "../TeamContext"

import styles from "./index.module.scss"

const Home = () => {
    const showInviteConfirmTimes = useRef(0)

    const user = useRoleInfo()
    const sessionReady = useSessionReady()
    const { inviteOpen, setInviteOpen } = usePageState()
    const inviteCode = new URLSearchParams(window.location.search).get("invite_code") ?? ""
    const joinedTeam = useJoinedTeam()
    const { data: actStatus } = useActivityStatus()

    // 未登录时直接弹出登录窗口
    useEffect(() => {
        if (sessionReady && !user) {
            login()
        }
    }, [sessionReady, user])

    const [ruleOpen, setRuleOpen] = useState(false)
    const [drawRefreshKey, setDrawRefreshKey] = useState(0)
    const refreshDraw = useCallback(() => setDrawRefreshKey((k) => k + 1), [])

    useEffect(() => {
        if (showInviteConfirmTimes.current > 0) {
            return
        }
        // 不是召回用户不弹
        if (!actStatus?.isRecallUser) {
            return
        }
        // 如果用户加入了team则不弹邀请弹窗
        if (joinedTeam.data) {
            return
        }
        if (inviteCode) {
            setInviteOpen(true)
            showInviteConfirmTimes.current = 1
        }
        return () => {
            setInviteOpen(false)
            showInviteConfirmTimes.current = 0
        }
    }, [inviteCode, joinedTeam.data, actStatus, setInviteOpen])

    return (
        <TeamProvider>
            <div className={styles.wrapper}>
                {/* 左侧抽奖部分 */}
                <Poster refreshKey={drawRefreshKey} />
                {/* 右侧任务面板 */}
                <Panel onRefreshDraw={refreshDraw} />
                {/* 邀请码填写弹窗 */}
                <InviteCodeModal
                    open={inviteOpen}
                    onCancel={() => setInviteOpen(false)}
                />
                <RuleModal open={ruleOpen} onCancel={() => setRuleOpen(false)} />
            </div>
        </TeamProvider>
    )
}

export default Home
